import React from 'react'
import { LPPureHtmlSection } from '../../api/Types'
import DynamicCallToAction from '../common/DynamicCallToAction'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'

type Props = LPPureHtmlSection

const LandingPagePureHtml: React.FunctionComponent<Props> = ({ style, html, css, cta }) => {
  return (
    <LandingPageSectionWrapper cssNamespace='pure-html-section' style={style}>
      {css && <style dangerouslySetInnerHTML={{ __html: css }} />}
      {html && <div className='pure-html-section-raw' dangerouslySetInnerHTML={{ __html: html }} />}
      {cta && <DynamicCallToAction cta={cta} />}
    </LandingPageSectionWrapper>
  )
}

export default LandingPagePureHtml
